import React from 'react'
import {Button, Card, CardBody, CardHeader, Col, Row} from 'reactstrap';

import {Button as SementicBtn, Dropdown, Form, Icon} from 'semantic-ui-react'
import './ViewAllCheckIn.css'
import {MDBDataTable} from 'mdbreact'
import SpinnerCheckBox from '../../../components/SpinnerCheckbox/SpinnerCheckBox'
import * as common from '../../../const/Common/CommonFunc';
import LabelInput from "../../../components/Input/LabelInput/LabelInput";
import LabelDropdown from "../../../components/Dropdown/LabelDropdown/LabelDropdown";
import {connect} from "react-redux";
import * as actionCreator from "../../../store/Action";
import Download from '../../../components/Button/DownloadbleButton'

import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import {Checkbox} from "semantic-ui-react";
import Cookies from "js-cookie";
import axios from "../../../axios/axios_visitortag";
import {Tooltip} from "antd";
import DrpDwn from "../../../components/Dropdown/Dropdown/DrpDwn";
import $ from 'jquery';
import apiConfig from "../../../axios/axios_api_services";
class ViewAllCheckIn extends React.Component {

  state = {
    multipleSelection: false,
    smsChecked: true,
    isTag: false,
    visitor: null, // ?
    search: false,
    visitorTag: {
      desc: null,
      tag: null
    },
    selectedColumn: "",
    searchDetails: "",
    visitors_list: [],

    isTagged: false,
    isCheckOut: false,
  };

  checkoutVisitors = () => {
    let checkout_visitor_array = [];

    let visitors = this.props.visitors;
    visitors.map((visitor, index) => {
      if (visitor.check) {
        checkout_visitor_array.push(visitor.meetingVisitorId);
      }
    });

    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    const obj = {
      visitors: checkout_visitor_array,
      sendSms: this.state.smsChecked
    };

    // Get All Current Check In User List Of Corporate
    axios.post(apiConfig.CORPORATE_VISITORS_CHECKOUT, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.getAllVisitors(1);
          this.setState({
            multipleSelection: false,
          });

        } else {
          this.props.spinnerHandler(false);
          common.warningAlert(response.data.message, 1);
          this.getAllVisitors(3);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.checkoutVisitors();
        } else {
          this.props.spinnerHandler(false)
        }
      });
  };
  DetailOnChange = (e, {value}) => {
    this.setState({selectedColumn: value});
  };
  DetailDescOnChange = (e) => {
    this.setState({searchDetails: e.target.value});
  };
  visitorTagOnChange = (e, {value}) => {
    const visitorTag = {
      ...this.state.visitorTag
    };
    visitorTag.tag = value;
    this.setState({
      visitorTag: visitorTag
    });
  };
  visitorDescOnChange = (e) => {
    const visitorTag = {
      ...this.state.visitorTag
    };
    visitorTag.desc = e.target.value;
    this.setState({
      visitorTag: visitorTag
    });
  };
  tagVisitors = () => {
    let tag_visitor_array = [];

    let visitors = this.props.visitors;
    visitors.map((visitor, index) => {
      if (visitor.tag) {
        tag_visitor_array.push(visitor.visitorId);
      }
    });

    let tag_visitor_obj = {
      visitors: tag_visitor_array,
      remarkColour: this.state.visitorTag.tag,
      remark: this.state.visitorTag.desc
    };

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axios.post(apiConfig.CORPORATE_VISITOR_TAG_REMARK(corporateId), tag_visitor_obj, {headers: headers})
      .then(response => {
        if (response.data.success) {

          this.getAllVisitors(2);
          this.setState({
            isTag: !this.state.isTag,
            multipleSelection: false,
          });

        } else {
          this.props.spinnerHandler(false);
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.tagVisitors();
        } else {
          this.props.spinnerHandler(false)
        }
      });

  };

  async buttonClick(e, type) {

    switch (type) {
      case 'details':
        if (this.state.searchDetails === null || this.state.selectedColumn === null || this.state.searchDetails.trim() === "" || this.state.selectedColumn.trim() === "") {
          common.notifyMessage("please select Column and fill Search Text");
          this.props.getAllVisitors_(this.state.visitors_list);
        } else {

          await this.getAllVisitors();
          let custom_array = [];

          let searchText = this.state.searchDetails.trim().toUpperCase();
          let searchCol = this.state.selectedColumn;

          let all_visitors = this.state.visitors_list;
          all_visitors.map((visitor, index) => {

            if (visitor[searchCol] !== null) {
              if (visitor[searchCol].toUpperCase().indexOf(searchText) > -1) {
                custom_array.push(visitor)
              }
            }
          });

          if (custom_array.length !== 0) {
            this.props.getAllVisitors_(custom_array);
          } else {
            // common.warningAlert("Not found", 1);
            this.props.getAllVisitors_(custom_array);
          }
        }

        break;
      case 'tag':
        if (!this.state.multipleSelection) {
          common.notifyMessage("Please Select Visitor!");
        } else if (this.state.visitorTag.desc === null || this.state.visitorTag.tag === null) {
          common.notifyMessage("please select Tag and Description");

        } else if (this.state.visitorTag.desc.trim() === "") {
          common.notifyMessage("please Enter Tag Description");
        } else {
          this.tagVisitors();
        }
        break;
      case 'tagEnable':
        this.setState({isTag: !this.state.isTag});
        break;
      case 'refresh':
        this.getAllVisitors();
        this.setState({multipleSelection: false});
        break;
      case 'checkOut':
        if (!this.state.multipleSelection) {
          common.notifyMessage("Please Select Visitor!");
        } else {
          swal({
            title: "Do you want to check out these visitors?",
            icon: are_you_sure_icon,
            closeOnClickOutside: false,
            buttons: {
              cancel: 'Cancel',
              dangerMode: {
                text: "Yes",
                value: "action",
                className: "okay-btn"
              }
            },
          }).then((value) => {
            switch (value) {
              case "action":
                this.checkoutVisitors();
                break;
              default:
            }
          });
        }
        break;
      default:
    }
  };

  async getAllVisitors(type) {
    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let coperateId = this.props.usr_obj.corporates[0].corporateId;
    // Get All Current Check In User List Of Corporate
    await axios.get(apiConfig.CORPORATE_VISITORS_CHECKIN(coperateId), {headers: headers})
      .then(async response => {
        let dup_array = [];
        this.props.spinnerHandler(false);

        if (response.data.success) {
          let visitors = response.data.visitorList;
          // console.log(visitors);

          if (visitors.length !== 0) {
            visitors.map((visitor, index) => {
              let obj = {...visitor, check: false, tag: false};
              dup_array.push(obj);
            })
          }
        }

        this.props.getAllVisitors_(dup_array);
        this.setState({
          visitors_list: dup_array
        });
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllVisitors(type);
        } else {
          this.props.spinnerHandler(false)
        }
      })

      .finally(fin => {
        // call get all counts
        this.props.callAllCount(this.props.usr_obj);

        if (type === 1) {
          common.warningAlert("Checkout successfully", 0)
        } else if (type === 2) {
          common.warningAlert("Tag visitor successfully", 0)
        }
      });
  };
  passnumberDropdownHandler = (e,{value}) => {
    let visitors = this.props.visitors;
    const passNumber = visitors[value].passNumber;

    visitors.map((v, i) => {
      if (v.passNumber === passNumber) {
        // visitors[i].check = !visitors[i].check;
        visitors[i].check = true;
      } else {
        // visitors[i].check = false;
      }
      visitors[i].tag = false;
    });
    this.props.getAllVisitors_(visitors);
    let exist = false;
    this.props.visitors.map((v, i) => {
      if (v.check) {
        exist = true;
      }
    });
    this.setState({multipleSelection: exist,isCheckOut: exist,isTagged: false});
    if (!exist) {
      this.setState({
        isTag: false
      })
    }
  };

  onCheckBoxChange(e, index) {
    switch (index) {
      case 'sms':
        this.setState({
          smsChecked: !this.state.smsChecked
        });
        break;
      default:

        let visitors = this.props.visitors;
        const passNumber = visitors[index].passNumber;

        visitors.map((v, i) => {
          if (v.passNumber === passNumber) {
            visitors[i].check = !visitors[i].check;
          } else {
            // visitors[i].check = false;
          }
          visitors[i].tag = false;
        });
        this.props.getAllVisitors_(visitors);

        let exist = false;
        this.props.visitors.map((v, i) => {
          if (v.check) {
            exist = true;
          }
        });
        this.setState({multipleSelection: exist,isCheckOut: exist,isTagged: false});
        if (!exist) {
          this.setState({
            isTag: false
          })
        }
    }
  };

  onTagCheckBoxChange(e, index) {
    let visitors = this.props.visitors;
    visitors[index].tag = !visitors[index].tag;

    visitors.map((v, i) => {
        visitors[i].check = false;
    });
    this.props.getAllVisitors_(visitors);

    let exist = false;
    this.props.visitors.map((v, i) => {
      if (v.tag) {
        exist = true;
      }
    });
    this.setState({multipleSelection: exist,isTagged: exist,isCheckOut:false});
    if (!exist) {
      this.setState({
        isTag: false
      })
    }
  };

  componentWillUnmount() {
    this.setState({
      multipleSelection: false
    })
  }

  componentDidMount() {
    this.getAllVisitors();
  }

  render() {
    let selectedVisitors = [];
    this.props.visitors.map((value, index) => {
      if (value.check) {
        selectedVisitors.push(
          {
            checkOut:
              <center>
                <SpinnerCheckBox check={value.check} onCheckBoxChange={e => this.onCheckBoxChange(e, index)}/>
              </center>,
            passNumber: value.passNumber,
            visitorIdentity: value.visitorIdentity,
            visitor: value.visitorName,
            visitorMobile: value.visitorMobile
          }
        );
      }
    });


    let table_selected_visitors_data = {columns:this.props.selectedVisitorsColumns, rows:selectedVisitors};
    let passnumber_dropdown = [];

    let rows = [];
    this.props.visitors.map((value, index) => {
      rows.push(
        {
          checkOut:
            <center>
              <SpinnerCheckBox check={value.check} onCheckBoxChange={e => this.onCheckBoxChange(e, index)}/>
            </center>,
          tagColor: <SpinnerCheckBox check={value.tag} isColor={value.tagColour !== null} color={value.tagColour}
                                     onCheckBoxChange={e => this.onTagCheckBoxChange(e, index)}/>,
          status: value.status,
          passNumber: value.passNumber,
          checkedIn: value.checkedIn,
          checkedOut: value.checkedOut !== null ? value.checkedOut : "-",
          host1: value.host1,
          host1Mobile: value.host1Mobile,
          host2: value.host2 !== null ? value.host2 : "-",
          host2Mobile: value.host2Mobile !== null ? value.host2Mobile : "-",
          visitor: value.visitorName,
          visitorIdentity: value.visitorIdentity,
          visitorMobile: value.visitorMobile,
          company: value.company !== null ? value.company : "-",
          purposeOfVisit: value.visitingPurpose,
          activatedPackage: value.activatedPackage !== null ? value.activatedPackage : "Not requested",
          generatedPin: value.generatedPin !== null ? value.generatedPin : "Not requested",
          expireDate: value.expireDate !== null ? value.expireDate : "Not requested",
          registrationStatus: value.registrationStatus,
          receptionName: value.receptionName
        }
      );

      let text = value.passNumber + " - " + value.visitorIdentity;
      const data = {
        key: index,
        text: text,
        value: index
      };
      passnumber_dropdown.push(data);

    });

    let columns = this.props.checkoutColumns;
    let table_data = {columns, rows};
    passnumber_dropdown.sort((a, b) => a.text.localeCompare(b.text));
    return (
      <div>
        {
          this.props.usr_obj.userRoles === "RECEPTION" ?
            <h4 className={"route-name-style"}>{this.props.route_name}</h4>
            :<h4 className={"route-none-style"}/>
        }
        <Row>
          <Col xs="12" sm="12" md="12" lg="12" xl="12">
            <Card>
              <CardHeader>
                Search Details
              </CardHeader>

              <CardBody className=" paddingBottom">
                <div className="form-group paddingBottom">
                  <Row>
                    <Col xs="4" sm="4" md="4" lg="4" xl="4">
                      <LabelDropdown
                        clearable
                        required
                        btnText={"Search"}
                        tagText={"Select Column"}
                        placeholder={"Select Column"}
                        options={this.props.column}
                        onChange={this.DetailOnChange}
                      />
                    </Col>
                    <Col xs="4" sm="4" md="5" lg="5" xl="5">
                      <LabelInput
                        required
                        tagText={"Search"}
                        placeholder={"Search Details"}
                        // value={this.state.host_extension}
                        onChange={this.DetailDescOnChange}
                      />
                    </Col>

                    <Col xs="4" sm="4" md="3" lg="3" xl="3">
                      <Row>
                        <Col xs="10" sm="10" md="10" lg="10" xl="10">
                          <Button
                            className="height"
                            block
                            color="primary"
                            onClick={e => this.buttonClick(e, 'details')}
                          >Search</Button>
                        </Col>

                        <Col xs="2" sm="2" md="2" lg="2" xl="2" style={{padding: '0'}}>
                          <Tooltip placement="topLeft" title="Refresh (current check-in visitors)">
                            <SementicBtn onClick={e => this.buttonClick(e, 'refresh')} circular icon='refresh'/>
                          </Tooltip>
                        </Col>
                      </Row>

                    </Col>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg="12">
            <Card className="card margin0">
              <CardHeader>
                Checkin Visitors
                {/*<LabelDropdown*/}
                  {/*btnText={"Get Info"}*/}
                  {/*tagText={"Staff Member"}*/}
                  {/*placeholder={"Enter name"}*/}
                  {/*options={passnumber_dropdown}*/}
                  {/*value={''}*/}
                  {/*// onSearchChange={this.handleSearchHost}*/}
                  {/*onChange={this.passnumberDropdownHandler}*/}
                {/*/>*/}
                {/*<Form>*/}
                  {/*<Form.Group widths='equal'>*/}
                    <DrpDwn
                      className={"searchvisitor-checkbox"}
                      placeholder={"Search visitor"}
                      options={passnumber_dropdown}
                      value={''}
                      onChange={this.passnumberDropdownHandler}
                    />

                  {/*</Form.Group>*/}
                {/*</Form>*/}
                <Download data={this.props.visitors} userType={"VISITOR_CHECKIN"}/>
              </CardHeader>
              <CardBody>

                {
                  this.state.multipleSelection ?
                    <Card className="card ">
                      <CardHeader className="paddingBottom">
                        <Row>
                          <Col sm="2">
                            {
                              this.state.isCheckOut ?
                                <Tooltip placement="topLeft" title="Check out visitors">
                                  <SementicBtn className="Width MarginBottom ui button px-5" onClick={e => this.buttonClick(e, 'checkOut')}
                                               icon='edit'/>
                                </Tooltip>
                                :null
                            }
                            {
                              this.state.isTagged ?
                                <div>
                                {/*<Tooltip placement="topLeft" title="Tag visitors">*/}
                                  {/*<SementicBtn className="Width MarginBottom ui button px-5" onClick={e => this.buttonClick(e, 'tagEnable')}*/}
                                               {/*icon='tags'/>*/}
                                {/*</Tooltip>*/}
                                Tag users
                                </div>
                                :null
                            }

                          </Col>
                          <Col sm="9">
                            {
                              this.state.isCheckOut ?
                                <Checkbox
                                  toggle
                                  checked={this.state.smsChecked}
                                  onChange={e => this.onCheckBoxChange(e, 'sms')}
                                  className="MarginBottom  MarginTop"
                                  label='Visitor Receives SMS'
                                />
                                :null
                            }

                          </Col>
                        </Row>
                      </CardHeader>
                      {
                        this.state.isTagged ?
                          <CardBody className="paddingBottom">
                            <div className="form-group">
                              <Row>
                                <Col xs="4" sm="4" md="4" lg="4" xl="4">
                                  <LabelDropdown
                                    required
                                    btnText={"Check Out"}
                                    tagText={"Select Tag"}
                                    placeholder={"Select Tag"}
                                    options={this.props.tags}
                                    onChange={this.visitorTagOnChange}
                                  />

                                </Col>
                                <Col xs="4" sm="4" md="5" lg="5" xl="5">
                                  <LabelInput

                                    tagText={"Tag Remark"}
                                    placeholder={"Tag Remark"}
                                    // value={this.state.host_extension}
                                    onChange={this.visitorDescOnChange}
                                  />
                                </Col>

                                <Col xs="3" sm="3" md="2" lg="2" xl="2">
                                  <Button
                                    className="height"
                                    block
                                    color="primary"
                                    onClick={e => this.buttonClick(e, 'tag')}
                                  >TagVisitor</Button>
                                </Col>
                              </Row>
                            </div>
                          </CardBody>
                          : null
                      }

                    </Card>
                    : null
                }

                {
                  selectedVisitors.length !== 0 ?
                    <Card className="card ">
                      <CardHeader className="paddingBottom">

                        Selected Visitors
                      </CardHeader>
                      <CardBody className=" paddingBottom">
                        <Row>
                          <Col lg="12">
                            <MDBDataTable
                              // id={"checkin-table-custom-style"}
                              displayEntries={false}
                              exportToCSV={true}
                              searching={false}
                              responsive
                              responsiveSm
                              responsiveMd
                              responsiveLg
                              responsiveXl
                              striped={false}
                              bordered
                              hover
                              data={table_selected_visitors_data}/>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                     :null
                }

                <Row>
                  <Col lg="12">
                    <MDBDataTable
                      id={"checkin-table-custom-style"}
                      exportToCSV={true}
                      searching={true}
                      searchLabel={"Search visitor"}
                      responsive
                      responsiveSm
                      responsiveMd
                      responsiveLg
                      responsiveXl
                      striped={false}
                      bordered
                      hover
                      data={table_data}/>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

  const mapStateToProps = (state) => ({
    visitors: state.viewAllCheckIN.visitors,
    checkInVisitors: state.viewAllCheckIN.checkInVisitors,
    checkoutColumns: state.viewAllCheckIN.checkoutColumns,
    column: state.viewAllCheckIN.column,
    selectedVisitorsColumns: state.viewAllCheckIN.selectedVisitorsColumns,
    tags: state.viewAllCheckIN.tags,

    usr_obj: state.userReducer.user,
  });

  const mapDispatchToProps = (dispatch) => {
    return {
      getAllVisitors_: (data) => dispatch(actionCreator.loadVisitors_(data)),
      callAllCount: (data) => dispatch(actionCreator.callAllCount(data)), // Get All counts

      // spinner handler
      spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    };
  };

  export default connect(mapStateToProps, mapDispatchToProps)(ViewAllCheckIn);
